import { useTranslation } from "react-i18next";

import { Carte, Vide } from "@/shared/ui";
import { DeviceMobileSlash, Monitor } from "@/shared/ui/icons";
import { Logo } from "@/shell/Logo";

/**
 * Écran de blocage mobile des rôles en KIOSQUE (chatteur, manager chatter).
 *
 * Leur poste de travail est une barre d'onglets fixe pensée pour un écran
 * d'ordinateur : densité d'information, multi-panneaux, cadence de chat. Et
 * ils n'ont ni taskbar ni liste des écrans du Bureau pour s'en sortir autrement. Plutôt que
 * de les laisser travailler dans de mauvaises conditions (et fausser les
 * analytics de shift), on bloque l'accès mobile et on demande l'ordinateur.
 *
 * Rendu par `CockpitShell` À LA PLACE du `MobileShell` quand `useIsMobile()`
 * est vrai ET que `resolveMobileGate` rend `"block"` — c'est-à-dire quand
 * `kioskRoleFor` reconnaît un kiosque. Les rôles qui gardent le Bureau (CEO,
 * Operator, VA) gardent l'accès mobile normal.
 *
 * La TitleBar (UserBadge → déconnexion, settings) vit au-dessus dans
 * `ChromeLayout`, donc quelqu'un de bloqué peut toujours se déconnecter ou
 * changer de langue depuis la barre du haut.
 *
 * 🪤 Les clés i18n restent `shell.mobileChatterBlock.*` alors que l'écran ne
 * vise plus le seul chatteur. C'est délibéré : rien ne teste la parité des
 * clés entre les trois locales, donc les renommer se joue à la main dans trois
 * fichiers et un oubli n'afficherait pas une erreur — i18next rendrait la clé
 * en toutes lettres, comme ça s'est déjà vu sur `panels.registry.cyrano.title`.
 * Le nom de la clé est une adresse, pas une description.
 */
export function MobileKioskBlock() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 bg-canvas px-8 py-12">
      <Logo className="h-12 w-12 text-fg opacity-90" />

      <Vide
        icone={<DeviceMobileSlash className="h-14 w-14" />}
        titre={t("shell.mobileChatterBlock.title")}
        texte={t("shell.mobileChatterBlock.subtitle")}
        action={
          <Carte remplissage="sm" className="flex w-auto items-center gap-2 px-4 text-xs font-medium text-muted">
            <Monitor className="h-4 w-4 shrink-0" />
            <span>{t("shell.mobileChatterBlock.hint")}</span>
          </Carte>
        }
      />
    </div>
  );
}
